/* eslint-disable jira/filename-case */
export const ALERTS_FEATURE = 'alerts' as const;
export const ONCALL_FEATURE = 'oncall' as const;
export const SERVICES_FEATURE = 'services' as const;
export const SIMILAR_ISSUES_FEATURE = 'similarIssues' as const;
export const SENTIMENT_FEATURE = 'sentiment-analysis' as const;
export const JSM_AI_CONTEXT = 'jsm-ai-context' as const;

export const AUTOMATICALLY_SET_REQUEST_TYPE_FEATURE = 'automaticallySetRequestType' as const;

export const CHANGE_MANAGEMENT_FEATURE = 'change-management' as const;
export const INCIDENT_MANAGEMENT_FEATURE = 'incident-management' as const;
export const PROBLEM_MANAGEMENT_FEATURE = 'problem-management' as const;
export const SERVICE_REQUEST_FEATURE = 'service-request' as const;
export const POST_INCIDENT_REVIEW_FEATURE = 'post-incident-review' as const;
export const CSM_CUSTOMER_CONTEXT_FEATURE = 'csm-customer-context' as const;
export const CSM_LIVE_CHAT_FEATURE = 'csm-live-chat' as const;
export const CSM_VOICE_FEATURE = 'csm-voice' as const;
export const CSM_DEVELOPER_ESCALATIONS_FEATURE = 'developer-escalation' as const;
export const CSM_PRODUCT_AND_ENTITLEMENTS_FEATURE = 'products-and-entitlements' as const;
export const JSM_VIEWS = 'jsm-views' as const;
export const JSM_BOARD = 'jsm-board' as const;
export const JSM_CALENDAR = 'jsm-calendar' as const;
export const JSM_LIST = 'jsm-list' as const;
export const JSM_PROJECT_SUMMARY = 'jsm-project-summary' as const;
export const JSM_PROJECT_SUMMARY_NEW_EXPERIENCE = 'jsm-project-summary-new-experience' as const;
export const JOURNEY_BUILDER = 'journey-builder' as const;
export const JSM_LIVE_CHAT = 'jsm-live-chat' as const;
export const SURVEYS = 'surveys' as const;
export const DEVELOPER_ESCALATIONS_FEATURE = 'developer-escalation' as const;
export const PLAYBOOK_FEATURE = 'playbooks' as const;
export const AUTOMATION_DISCOVERABILITY_FEATURE = 'automation-discoverability' as const;
export const JCS_CUSTOMER_SUPPORT_ESCALATION_FEATURE = 'jcs-customer-support-escalation' as const;
export const RCA_INVESTIGATION_FEATURE = 'root-cause-analysis' as const;
export const CASE_MANAGEMENT_FEATURE = 'case-management' as const;
export const JSM_WORKFORCE_OPTIMIZATION = 'jsm-workforce-optimization' as const;
export const JSM_WORKDAY_PANEL_INTEGRATION = 'jsm-workday-panel-integration' as const;

export const ENABLED = 'ENABLED' as const;
export const DISABLED = 'DISABLED' as const;

export type WorkCategoryFeature =
	| typeof CHANGE_MANAGEMENT_FEATURE
	| typeof INCIDENT_MANAGEMENT_FEATURE
	| typeof PROBLEM_MANAGEMENT_FEATURE
	| typeof SERVICE_REQUEST_FEATURE
	| typeof POST_INCIDENT_REVIEW_FEATURE
	| typeof DEVELOPER_ESCALATIONS_FEATURE
	| typeof CASE_MANAGEMENT_FEATURE;

export type Feature =
	| WorkCategoryFeature
	| typeof ALERTS_FEATURE
	| typeof ONCALL_FEATURE
	| typeof SERVICES_FEATURE
	| typeof SIMILAR_ISSUES_FEATURE
	| typeof SENTIMENT_FEATURE
	| typeof JSM_AI_CONTEXT
	| typeof AUTOMATICALLY_SET_REQUEST_TYPE_FEATURE
	| typeof CSM_CUSTOMER_CONTEXT_FEATURE
	| typeof CSM_LIVE_CHAT_FEATURE
	| typeof CSM_VOICE_FEATURE
	| typeof CSM_DEVELOPER_ESCALATIONS_FEATURE
	| typeof CSM_PRODUCT_AND_ENTITLEMENTS_FEATURE
	| typeof JSM_PROJECT_SUMMARY
	| typeof JSM_PROJECT_SUMMARY_NEW_EXPERIENCE
	| typeof SURVEYS
	| typeof JOURNEY_BUILDER
	| typeof JSM_LIVE_CHAT
	| typeof JSM_VIEWS
	| typeof JSM_CALENDAR
	| typeof JSM_BOARD
	| typeof JSM_LIST
	| typeof PLAYBOOK_FEATURE
	| typeof AUTOMATION_DISCOVERABILITY_FEATURE
	| typeof JCS_CUSTOMER_SUPPORT_ESCALATION_FEATURE
	| typeof RCA_INVESTIGATION_FEATURE
	| typeof JSM_WORKFORCE_OPTIMIZATION
	| typeof JSM_WORKDAY_PANEL_INTEGRATION;

export type FeatureStatus = typeof ENABLED | typeof DISABLED;
